<template>
    <div class="business-select">
        <v-tip
            ref="dynamicData"
            placement="top"
            kind="small"
            clazz="data-rule-select-tips"
        >
            <template slot-scope="props">
                <span>{{ props.data }}</span>
            </template>
        </v-tip>
        <v-cascader
            v-model="curSelect"
            :options="businessOptions"
            @change="onChange"
        >
            <template
                slot="item"
                slot-scope="props"
            >
                <span class="v-cascader-menu__inner">
                    {{ props.item.text }}
                    <v-icon
                        v-if="props.item.tip"
                        v-tip:dynamicData.hover.delay="props.item.tip"
                        name="basic_help_line"
                        class="data-rule-select-icon"
                        remote
                    />
                </span>
            </template>
            <template
                slot="header"
                slot-scope="props"
            >
                <div>
                    <span>{{ curSelect.length ?
                        props.item.reduce(
                            (pre, cur) => pre + (pre ? '/' : '') + cur.text,
                            ''
                        ) :
                        '业务类型' }}
                    </span>
                </div>
            </template>
        </v-cascader>
    </div>
</template>

<script>

export default {
  props: {
    selected: {
      type: [Number, String, Array],
      default: '',
    },
  },

  data() {
    return {
      lastVal: '',
      businessOptions: [],
      curSelect: [],

    };
  },

  watch: {
    businessOptions() {
      this.selected ? this.curSelected(this.selected) : '';
    },

    selected(cur) {
      cur ? this.curSelected(cur) : '';
    },
  },

  created() {
    this.getBusinessList();
  },

  methods: {
    curSelected(cur) {
      if (!Array.isArray(cur)) {
        this.businessOptions.forEach(((sitem) => {
          if (sitem.value == cur && !sitem.children) {
            this.curSelect = [cur];
          } else if (sitem.children && sitem.children.length) {
            sitem.children.forEach(((item) => {
              if (item.value == cur) {
                this.curSelect = [sitem.value, cur];
              }
            }));
          }
        }));
      } else {
        this.curSelect = cur;
      }
    },

    getBusinessList() {
      this.$ajax.gatewayPost('/v1/sharedPrivilege/boList', {}).then((data) => {
        const boList = (data && data.data && data.data.bo_info) || [];
        this.businessOptions = boList.map((boItem) => {
          const { bo_id: boId, name, tip, children } = boItem || {};
          if (children && children.length) {
            return {
              value: boId === 0 ? '0' : boId,
              text: name,
              tip,
              children: children.map((item) => {
                const { bo_id: boId, name, tip } = item || {};
                return {
                  value: boId,
                  text: name,
                  tip,
                };
              }),
            };
          }
          return {
            value: boId,
            text: name,
            tip,
          }
          ;
        });
      });
    },

    getBusinessDetailById(id) {
      this.$emit('loading', true);
      this.$ajax.gatewayPost('/v1/sharedPrivilege/sharedBoMeta', {
        bo_id: id,
      })
        .then((data) => {
          this.$emit('change', {
            id,
            data: this.formatBoInfo(data.data),
          });

          this.$emit('loading', false);
        });
    },

    formatBoInfo(data) {
      const { bo_info: boInfo, def } = data || {};
      const { metas } = boInfo || {};
      const checkedOptList = (def && def.ops) || [];
      const optList = [];
      const ruleList = [];

      metas.forEach((item) => {
        const { type, name, description, detail } = item || {};
        if (type === 2) {
          optList.push({
            value: name,
            text: description,
          });
        } else if (type === 4) {
          const detailObj = JSON.parse(detail);
          ruleList.push(detailObj);
        }
      });

      return {
        optList,
        ruleList,
        checkedOptList,
      };
    },

    onChange(value) {
      const val =  Array.isArray(value) ? value[value.length - 1] : value;
      if (val && this.lastVal !== val) {
        this.getBusinessDetailById(val);
      }

      this.lastVal = val;
    },
  },
};
</script>
<style lang="less" scoped>
@import './index.less';
</style>
